<template>
  <div id="app">
    <Alert />
    <!-- Global loading overlay for route transitions -->
    <div v-if="isLoading" class="route-loading-overlay">
      <div class="route-loading-spinner">
        <i class="fa fa-spinner fa-spin"></i>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import Alert from "@/components/Alert.vue";

export default {
  name: 'App',
  components: {
    Alert
  },
  data() {
    return {
      isLoading: false
    };
  },
  created() {
    // Listen for loading events from child components
    this.$root.$on('show-loading', () => {
      this.isLoading = true;
    });

    // Show loading overlay during route transitions
    this.$router.beforeEach((to, from, next) => {
      // Only show loader when navigating between student portal pages
      const studentRoutes = ['student-dashboard', 'student-course-assignments', 'student-assignment-detail'];
      if (from.name && studentRoutes.includes(from.name) && studentRoutes.includes(to.name)) {
        this.isLoading = true;
      }
      next();
    });

    this.$router.afterEach(() => {
      // Hide loading overlay after route transition completes
      this.isLoading = false;
    });
  }
}
</script>

<style>
@import './styles/viva-classes.css';
@import './styles/video-js.css';

/* Global styles - not scoped */
body, html {
  background-color: var(--viva-cream);
  margin: 0;
  padding: 0;
}

#app {
  background-color: var(--viva-cream);
  min-height: 100vh;
}

/* Route loading overlay */
.route-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(254, 250, 239, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.route-loading-spinner {
  text-align: center;
}

.route-loading-spinner i {
  font-size: 48px;
  color: var(--viva-orange);
}

</style>